import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { FileText, LayoutGrid, Network, Search } from "lucide-react"

const methodologySteps = [
  {
    title: "Topical Maps",
    description: "Create comprehensive topic hierarchies that establish your site as an authority in your field through strategic content organization.",
    icon: Network,
    ariaLabel: "Topical Maps methodology step"
  },
  {
    title: "Content Networks",
    description: "Build interconnected content networks that strengthen your topical authority and improve search engine understanding.",
    icon: LayoutGrid,
    ariaLabel: "Content Networks methodology step"
  },
  {
    title: "Contextual Vectors",
    description: "Optimize content relevance through strategic use of contextual vectors and semantic relationships.",
    icon: Search,
    ariaLabel: "Contextual Vectors methodology step"
  },
  {
    title: "Content Briefs",
    description: "Create detailed content briefs that guide the development of semantically optimized content aligned with your topical authority goals.",
    icon: FileText,
    ariaLabel: "Content Briefs methodology step"
  }
]

export function Methodology() {
  return (
    <section className="py-12" aria-label="Our Methodology">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4">Our Methodology</h2>
        <p className="text-xl text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          A comprehensive approach to semantic SEO that focuses on building authority through content organization and contextual relevance
        </p>
        <div className="grid md:grid-cols-2 gap-8">
          {methodologySteps.map((step, index) => (
            <Card 
              key={index} 
              className="backdrop-blur-lg border-primary/20 transition-all duration-300 hover:shadow-lg hover:border-primary/40"
              aria-label={step.ariaLabel}
            >
              <CardHeader>
                <step.icon className="h-8 w-8 text-primary mb-4" aria-hidden="true" />
                <CardTitle>{step.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{step.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}